import { post, get } from '../network/index.js'
// 时间方案页面≈
const planList = data => {
  return post('/mercWebi/busServiceTime/listPlan', data)
}
// 方案详情
const queryDetail = data => {
  return post('/mercWebi/busServiceTime/queryDetail', data)
}
// 服务开始时间列表
const getServiceTimeList = data => {
  return post('/mercWebi/busServiceTime/getServiceTimeList', data)
}
// 添加方案页面
const createPlan = data => {
  return post('/mercWebi/busServiceTime/createPlan', data)
}

//  方案日期
const listTimeInfo = data => {
  return post('/mercWebi/busServiceTime/listTimeInfo', data)
}
// 单个时间约满状态
const updateTimePage = data => {
  return post('/mercWebi/busServiceTime/updateTimeStatus', data)
}

// 日期全部约满状态
const updateDateStatus = data => {
  return post('/mercWebi/busServiceTime/updateDateStatus', data)
}

//新增商家服务开始时间
const createStartTime = data => {
  return post('/mercWebi/busServiceTime/createStartTime', data)
}
//删除开始时间项
const deleteTimeName = data => {
  return post('/mercWebi/busServiceTime/deleteTimeName', data)
}
//新增商家服务约满日期
const createFullTime = data => {
  return post('/mercWebi/busServiceTime/createFullTime', data)
}
//删除方案日期项
const deleteDateByID = data => {
  return post('/mercWebi/busServiceTime/deleteDateByID', data)
}
//更新方案页面
const updatePlan = data => {
  return post('/mercWebi/busServiceTime/updatePlan', data)
}

const queryConfigInfo = data => {
  return post('/mercWebi/system/getOptionList', data)
}

const updateConfig = data => {
  return post('/mercWebi/system/updateOption', data)
}
//分页查询商家第三方列表
const listTrilateralMerc = data => {
  return post('/mercWebi/trilateralManager/listTrilateralMerc', data)
}
//开通和关闭第三方平台状态
const modifyTrilateralStatus = data => {
  return post('/mercWebi/trilateralManager/modifyTrilateralStatus', data)
}

//开通和关闭第三方平台状态
const modifyTrilateralSign = data => {
  return post('/mercWebi/busServiceTime/modifyTrilateralSign', data)
}
// 获取商户详情
const listMercInfoDetail = data => {
  return get('/mercWebi/mercInfo/listMercInfoDetail', data)
}
// 修改商户信息
const updateMercInfo = data => {
  return post('/mercWebi/mercInfo/updateMercInfo', data)
}

//查询微信支付配置
const queryWxPay = data => {
  return post('/mercWebi/mercInfo/queryWxPay', data)
}
//查询支付宝支付配置
const queryAliPay = data => {
  return post('/mercWebi/mercInfo/queryAliPay', data)
}
//添加其他支付
const addOtherChannel = data => {
  return post('/mercWebi/payChannel/addOtherChannel', data)
}
//其他支付列表
const queryOtherList = data => {
  return get('/mercWebi/payChannel/queryOtherList', data)
}
//其他支付排序
const sortOtherChannel = data => {
  return post('/mercWebi/payChannel/sortOtherChannel', data)
}
//编辑支付排序
const updateOtherChannel = data => {
  return post('/mercWebi/payChannel/updateOtherChannel', data)
}
//查询洗护功能周期
const getCareList = data => {
  return post('/mercWebi/system/getCareList', data)
}
//查询衣物属性列表与附件
const getOrderGoodsDescribeList = data => {
  return post('/mercWebi/orderGoodsDescribe/getOrderGoodsDescribeList', data)
}
//修改衣物属性列表与附件
const updateOrderGoodsDescribe = data => {
  return post('/mercWebi/orderGoodsDescribe/updateOrderGoodsDescribe', data)
}
//删除衣物属性列表与附件
const deleteOrderGoodsDescribes = data => {
  return post('/mercWebi/orderGoodsDescribe/deleteOrderGoodsDescribes', data)
}
//排序衣物属性列表与附件
const updateOrderGoodsDescribeForSort = data => {
  return post('/mercWebi/orderGoodsDescribe/updateOrderGoodsDescribeForSort', data)
}
//添加衣物属性列表与附件
const addOrderGoodsDescribe = data => {
  return post('/mercWebi/orderGoodsDescribe/addOrderGoodsDescribe', data)
}
//商家-设置参数
const listSysDictParam = data => {
  return post('/mercWebi/webSysDictParam/listSysDictParam', data)
}
//商家-更新设置
const updateSysDictParam = data => {
  return post('/mercWebi/webSysDictParam/updateSysDictParam', data)
}

//字典 - 查询指定code字典
const listSysDictByCode = data => {
  return post('/mercWebi/webSysDict/listSysDictByCode', data)
}

//字典 - 查询系统内所有字典
const listSysDict = data => {
  return post('/mercWebi/webSysDict/listSysDict', data)
}


export default {
  planList,
  getServiceTimeList,
  createPlan,
  updateTimePage,
  listTimeInfo,
  updateDateStatus,
  createStartTime,
  deleteTimeName,
  createFullTime,
  deleteDateByID,
  queryConfigInfo,
  updateConfig,
  updatePlan,
  queryDetail,
  listTrilateralMerc,
  modifyTrilateralStatus,
  modifyTrilateralSign,
  listMercInfoDetail,
  updateMercInfo,
  queryWxPay,
  queryAliPay,
  addOtherChannel,
  queryOtherList,
  sortOtherChannel,
  updateOtherChannel,
  getCareList,
  getOrderGoodsDescribeList,
  updateOrderGoodsDescribe,
  deleteOrderGoodsDescribes,
  updateOrderGoodsDescribeForSort,
  addOrderGoodsDescribe,
  listSysDictParam,
  updateSysDictParam,
  listSysDictByCode,
  listSysDict
}
